// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"6468c5ad","97":"11ec1b6a","164":"151236de","189":"4b5ae5e3","201":"b84ecacb","325":"e416e5d4","356":"99c392a1","367":"46000d04","379":"8c2a987c","495":"5b51db0b","559":"84416cea","653":"fd11a994","689":"063cf557","893":"7c312b31","965":"ad277d22"}[chunkId] + ".chunk.js";
};